/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePropertyResponse } from '../models/CreatePropertyResponse';
import type { DeletePropertyResponse } from '../models/DeletePropertyResponse';
import type { UpdatePropertyRequest } from '../models/UpdatePropertyRequest';
import type { UpdatePropertyResponse } from '../models/UpdatePropertyResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PropertyControllerService {
    /**
     * @param tenantId
     * @returns any OK
     * @throws ApiError
     */
    public static propertyControllerGetAllProperties(
        tenantId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/properties',
            query: {
                'tenantId': tenantId,
            },
        });
    }
    /**
     * @param propertyId
     * @param requestBody Update property request
     * @returns UpdatePropertyResponse Update property response
     * @throws ApiError
     */
    public static propertyControllerUpdateProperty(
        propertyId: string,
        requestBody?: UpdatePropertyRequest,
    ): CancelablePromise<UpdatePropertyResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v0/api/property/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param propertyId
     * @returns any OK
     * @throws ApiError
     */
    public static propertyControllerGetProperty(
        propertyId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/property/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
        });
    }
    /**
     * @param propertyId
     * @returns DeletePropertyResponse Delete property response
     * @throws ApiError
     */
    public static propertyControllerDeleteProperty(
        propertyId: string,
    ): CancelablePromise<DeletePropertyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v0/api/property/{propertyId}',
            path: {
                'propertyId': propertyId,
            },
        });
    }
    /**
     * @param requestBody Create a new property with a file upload
     * @param tenantId
     * @returns CreatePropertyResponse Create property response
     * @throws ApiError
     */
    public static propertyControllerCreateProperty(
        requestBody: {
            /**
             * Address of the property
             */
            address?: string;
            /**
             * URL of the map image representing the property
             */
            mapImageUrl?: string;
            /**
             * Longitude of the property location
             */
            longitude?: number;
            /**
             * Latitude of the property location
             */
            latitude?: number;
            /**
             * Name of the head of the house
             */
            houseHeadName?: string;
            /**
             * Occupation of the property owner or resident
             */
            scopeOccupation?: Record<string, any>;
            /**
             * Date of transaction
             */
            dot?: string;
            /**
             * Date of birth
             */
            dob?: string;
            /**
             * Birthplace of the owner
             */
            birthPlace?: string;
            /**
             * Problems being faced at the property
             */
            problemFacing?: Array<string>;
        },
        tenantId?: string,
    ): CancelablePromise<CreatePropertyResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v0/api/property',
            query: {
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
